import * as queryString from 'query-string';
import { Location } from '../../common/utils/Location';

export enum DebugMode {
  none,
  remote,
  local,
}

const microViewDebugQueryParameter = 'microViewDebug';

export class SearchMicroViewService {
  public static instance = new SearchMicroViewService();

  public getDebugMode(): DebugMode {
    const queryParameters = queryString.parse(Location.search());
    const value = queryParameters[microViewDebugQueryParameter];
    return (DebugMode[value] as unknown as DebugMode) || DebugMode.none;
  }

  public getUrlRootPath(): string {
    return this.getDebugMode() === DebugMode.local ? '.' : './content-exploration/search-microview';
  }
}
